// extracted by mini-css-extract-plugin
export var item = "item-module--item--1ZSXf";
export var iconWrap = "item-module--iconWrap--1JWDz";
export var title = "item-module--title--1nhEv";